import React from 'react';
import { useEditorStore } from '@/stores';

export function CanvasControls() {
  const { zoom, setZoom, panOffset, resetPan, showGrid, toggleGrid, fitToView } = useEditorStore();

  const hasPanOffset = panOffset.x !== 0 || panOffset.y !== 0;

  const handleZoomIn = () => setZoom(zoom + 0.1);
  const handleZoomOut = () => setZoom(zoom - 0.1);
  const handleFit = () => {
    const container = document.querySelector('.flex-1.relative.overflow-hidden');
    if (container) {
      fitToView(container.clientWidth - 96, container.clientHeight - 96);
    }
  };

  const zoomPercent = Math.round(zoom * 100);

  return (
    <div className="absolute top-4 right-4 flex items-center gap-2">
      {/* Zoom controls */}
      <div className="flex items-center gap-1 bg-navy-light/80 backdrop-blur rounded-lg p-1">
        <button
          onClick={handleZoomOut}
          disabled={zoom <= 0.1}
          className="w-7 h-7 flex items-center justify-center text-fg-muted hover:text-fg disabled:opacity-30 rounded transition-colors"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>

        <span className="w-12 text-center text-xs font-medium text-fg tabular-nums">
          {zoomPercent}%
        </span>

        <button
          onClick={handleZoomIn}
          disabled={zoom >= 3}
          className="w-7 h-7 flex items-center justify-center text-fg-muted hover:text-fg disabled:opacity-30 rounded transition-colors"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>
      </div>

      {/* Fit to view */}
      <button
        onClick={handleFit}
        className="w-8 h-8 flex items-center justify-center bg-navy-light/80 backdrop-blur rounded-lg text-fg-muted hover:text-fg transition-colors"
        title="Fit to view"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
        </svg>
      </button>

      {/* Reset pan (only show when panned) */}
      {hasPanOffset && (
        <button
          onClick={resetPan}
          className="w-8 h-8 flex items-center justify-center bg-navy-light/80 backdrop-blur rounded-lg text-primary hover:text-primary-light transition-colors"
          title="Reset pan position"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
          </svg>
        </button>
      )}

      {/* Grid toggle */}
      <button
        onClick={toggleGrid}
        className={`w-8 h-8 flex items-center justify-center bg-navy-light/80 backdrop-blur rounded-lg transition-colors ${
          showGrid ? 'text-primary' : 'text-fg-muted hover:text-fg'
        }`}
        title="Toggle grid"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
        </svg>
      </button>
    </div>
  );
}
